import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { apiClient } from '../api/client';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Memoized Stripe.js loader for Embedded Checkout. The publishable key is
 * fetched from the backend (`/auth/stripe-config`) so it stays environment-
 * agnostic (dev/staging/prod read it from settings / Secret Manager) and we
 * don't need a build-time VITE var. Publishable keys are safe to expose.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = apiClient
      .get('/auth/stripe-config')
      .then((r) => loadStripe(r.data?.publishable_key || ''))
      .catch(() => loadStripe(''));
  }
  return stripePromise;
}
